import React, { MouseEventHandler, ReactNode } from 'react'
import { MenuItem } from '@headlessui/react'

export interface ActionMenuItemProps {
  onClick: MouseEventHandler<HTMLButtonElement>
  label: React.ReactNode
  dataTestAttributes?: Record<string, string>
}

export const ActionMenuItem = ({
  dataTestAttributes,
  onClick,
  label,
}: ActionMenuItemProps): ReactNode => (
  <MenuItem key={'action-settings'}>
    {({ focus }) => (
      <button
        onClick={onClick}
        aria-pressed={focus}
        type="button"
        className={`group flex w-full items-center gap-2 border-b border-text-secondary/30 px-4 py-3 text-left text-sm main-transition-colors last:border-0 aria-pressed:text-brand-primary lg:py-2`}
        {...dataTestAttributes}
      >
        <span>{label}</span>
      </button>
    )}
  </MenuItem>
)
